/* eslint-disable camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import BankAccountForm from "./BankAccountForm/BankAccountForm";
import CreditCardForm from "./CreditCardForm/CreditCardForm";
import Modal from "../Modal/Modal";
import Image from "../Image/Image";

import "./AddPaymentMethodModal.scss";

class AddPaymentMethodModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			show: false,
			type: "bankAccount",
		};
	}

	resetState = () => {
		// By setting type = '', forms will unmount and reset its internal state
		this.setState({ show: false, type: "" });
	};

	openModal = () => {
		this.setState({ show: true, type: "bankAccount" });
	};

	onRadioChange = event => {
		this.setState({ type: event.target.value });
	};

	onFormSubmit = result => {
		const { onSubmit } = this.props;
		this.resetState();

		onSubmit(result);
	};

	successCallback = () => {
		const { callback } = this.props;
		this.resetState();

		if (callback) callback();
	};

	render() {
		const { lang } = global;
		const { type, show } = this.state;
		const { user, onSubmit } = this.props;

		const userAddress = {
			address_line1: user.StreetAddress,
			address_city: user.City,
			_state: user.StateId,
			address_state: `${user.StateAbbreviation} - ${user.StateName}`,
			address_zip: user.Zip,
		};

		return (
			<Modal
				show={show}
				onHide={this.resetState}
			>
				<Modal.Header closeButton>
					<Modal.Title>{lang.t("Add Payment Method")}</Modal.Title>
				</Modal.Header>
				<Modal.Body id="payment-form">
					<div id="payment-form-title">
						<h4>{lang.t("Payment Method")}</h4>
						<Image src="/images/cardImage.png" />
					</div>
					<div id="payment-form-types">
						<div className="radio">
							<label htmlFor="paymentType_bankAccount">
								<input
									type="radio"
									name="paymentType"
									value="bankAccount"
									id="paymentType_bankAccount"
									onChange={this.onRadioChange}
									checked={type === "bankAccount"}
								/>
								{lang.t("ACH Bank Transfer")}
							</label>
						</div>
						<div className="radio">
							<label htmlFor="paymentType_creditCard">
								<input
									type="radio"
									name="paymentType"
									value="creditCard"
									id="paymentType_creditCard"
									onChange={this.onRadioChange}
									checked={type === "creditCard"}
								/>
								{lang.t("Credit Card")}
							</label>
						</div>
					</div>
					<Choose>
						<When condition={type === "bankAccount"}>
							<BankAccountForm
								successCallback={this.successCallback}
								onCancel={this.resetState}
								onSubmit={onSubmit ? this.onFormSubmit : undefined}
							/>
						</When>
						<When condition={type === "creditCard"}>
							<CreditCardForm
								userAddress={userAddress}
								successCallback={this.successCallback}
								onCancel={this.resetState}
								onSubmit={onSubmit ? this.onFormSubmit : undefined}
							/>
						</When>
					</Choose>
				</Modal.Body>
			</Modal>
		);
	}
}

AddPaymentMethodModal.propTypes = {
	user: PropTypes.object,
	callback: PropTypes.func,
	onSubmit: PropTypes.func,
};

AddPaymentMethodModal.defaultProps = {
	user: {},
	callback: undefined,
	onSubmit: undefined,
};

export default AddPaymentMethodModal;
